export default {
    text: 'Durch die Nutzung dieser Website stimmst du unserer',
    cookie_policy: 'Cookie-Policy zu.',
    buttons: {
        accept: 'Akzeptieren',
        reject: 'Ablehnen',
    },
}